import { Trans } from '@lingui/macro';
import { Button, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { isStandalone } from '../../lib/detect';
import { isIOS } from '../../lib/detect/platforms';
import { usePushNotifyPerms } from './use-push-notify-perms';

export const PushNotifyAccessRequest = observer(() => {
  const [{ permState, isLoading, isActive }, { subscribe }] =
    usePushNotifyPerms();

  console.log({ permState });

  // если iOS и isNotSupported, добавьте приложение на главный экран
  const isNotSupported = permState.state === 'unsupported';
  const isDenied = permState.state === 'denied';

  if (isNotSupported) return null;
  if (isIOS() && !isStandalone()) return null;
  if (isActive) return null;

  const message = isDenied ? (
    isIOS() ? (
      <Trans>
        Кажется, Вы запретили приложению присылать вам уведомления. Для
        получения уведомлений зайдите в настройки телефона и разрешите
        показывать уведомления для Railway AM
      </Trans>
    ) : (
      <Trans>
        Кажется, Вы запретили приложению присылать вам уведомления. Для
        получения уведомлений зайдите в настройки телефона и разрешите
        показывать уведомления для "pass.railway.am" или Railway AM
      </Trans>
    )
  ) : (
    <Trans>
      Для получения уведомлений без запуска приложения требуется ваше
      разрешение. Обещаем не беспокоить вас по пустякам.
    </Trans>
  );

  return (
    <UiCard title={<Trans>Уведомления</Trans>}>
      <Stack>
        <p style={{ margin: 0 }}>{message}</p>

        {isDenied ? null : (
          <Button
            variant="outline"
            size="md"
            onClick={subscribe}
            fullWidth
            loading={isLoading}
          >
            <Trans>Включить уведомления</Trans>
          </Button>
        )}
      </Stack>
    </UiCard>
  );
});
